// extracted by mini-css-extract-plugin
export default {"container":"Setting_container__2YB34","input":"Setting_input__ZibpU","div1":"Setting_div1__Buick","div2":"Setting_div2__sYEbI","div3":"Setting_div3__ck6eT"};